import { useEffect } from 'react';
import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuthStore } from '../store/authStore';

/**
 * Guarda de ruta: exige sesión. Mientras hidrata (/auth/me) muestra un estado
 * de carga sobrio; sin sesión redirige a /login preservando el destino para
 * volver tras autenticarse.
 */
export function ProtectedRoute() {
  const status = useAuthStore((s) => s.status);
  const hydrate = useAuthStore((s) => s.hydrate);
  const location = useLocation();

  useEffect(() => {
    if (status === 'idle') void hydrate();
  }, [status, hydrate]);

  if (status === 'idle' || status === 'hydrating') {
    return (
      <div className="flex min-h-screen items-center justify-center bg-surface-base">
        <span className="flex items-center gap-2 text-content-muted">
          <Loader2 className="h-5 w-5 animate-spin" aria-hidden="true" />
          <span className="font-sans text-sm">Cargando tu sesión…</span>
        </span>
      </div>
    );
  }

  if (status === 'anonymous') {
    return <Navigate to="/login" replace state={{ from: location }} />;
  }

  return <Outlet />;
}
